import React from "react";
import { Styled } from './styled';
import Quote from "~/components/quote";
import {SellMoreScreen} from "~common/sell-more-screen";

const Quality = () => {
  return (
    <>
      <Styled.Container>
        <Styled.Title>
          Оценка качества
        </Styled.Title>
        <Styled.TextBold>Оценка качества — это модуль, который после окончания разговора
          просит клиента оценить качество обслуживания от 1 до 5. Уведомление о плохой
          оценке сразу уходит на почту, а статистика по оценкам собирается
          в отчет.</Styled.TextBold>
        <Styled.Text>
          <Styled.Indent/>
          <Styled.Indent/>
          Расскажем как это работает на примере кейса нашего клиента.
          <Styled.Indent/>
          Компания Николая продает системы фильтрации воды и расходники к ним. В его отделе продаж 3 человека. На одном из маркетплэйсов Николай увидел негативные отзывы о своей компании. Клиенты писали, что менеджеры не разбираются в продукте, навязывают дорогие фильтры, манипулируют и грубят при отказе.
          <Styled.Indent/>
          Николай удивился, т. к. иногда слушал звонки менеджеров и в целом был ими доволен. По отзывам было непонятно в какой день случился инцидент и как отыскать проблемный звонок среди остальных. Чтобы разобраться в ситуации, Николай подключил услугу «Оценка качества» от onlinePBX .
        </Styled.Text>
        <Styled.Image src={process.env.PUBLIC_DIR + '/images/features-page/marketing/report-screen-2.svg'} />
        <Styled.BlockQuote>
          <Quote width='800'>
            <Styled.TextBold>Николай, владелец бизнеса</Styled.TextBold>
            <Styled.Indent/>
            <Styled.TextComment>У меня нет времени слушать звонки каждого менеджера, а нанимать отдельного человека на прослушку и платить ему зарплату не хотелось. Я подключил «Оценку качества» и стал получать уведомления о плохих оценках на почту. Послушал звонки с плохими оценками — один из менеджеров действительно вел себя некорректно. Мы разобрали с ним эти кейсы и установили испытательный срок. Менеджер его не прошел и мы попрощались. У нового менеджера 90% оценок отличные.</Styled.TextComment>
            <Styled.Indent/>
            <Styled.TextComment>На хорошие оценки я тоже обращаю внимание, когда хочу выписать премию. Так что оценка качества помогла мне разобраться и с негативными отзывами на маркетплейсах, и сократить время на прослушку и помогает при премировании.</Styled.TextComment>
          </Quote>
        </Styled.BlockQuote>
        <Styled.Block>
          <Styled.ImageRating src={process.env.PUBLIC_DIR + '/images/features-page/marketing/good-rating.svg'} />
          <Styled.ImageRating src={process.env.PUBLIC_DIR + '/images/features-page/marketing/bad-rating.svg'} />
        </Styled.Block>
      </Styled.Container>
      <Styled.SelMore className="onlinepbx__sel__more">
        <SellMoreScreen />
      </Styled.SelMore>
    </>
  )
}

export default Quality
